import { register, locale, init, getLocaleFromNavigator, format, _ } from 'svelte-i18n';

import { LANG_DICT } from '../constants';
import { loadLanguageAsset } from 'src/helpers/language_asset_loader';

export function setDictionary() {
	for (const key in LANG_DICT) {
		if (Object.prototype.hasOwnProperty.call(LANG_DICT, key)) {
			register(key, async () => {
				try {
					return (await import(`../lang/${key}.json`)).default;
				} catch (error) {
					console.error(`[i18n] Failed to load dictionary for "${key}":`, error);
					return (await import('../lang/en.json')).default;
				}
			});
		}
	}

	init({
		fallbackLocale: 'en',
		initialLocale: getLocaleFromNavigator(),
	});
}

export async function setUpI18n(userLang): Promise<string> {
	console.log('userLang', userLang);
	let lang = userLang in LANG_DICT ? userLang : 'en';

	try {
		await loadLanguageAsset(lang);
	} catch (error) {
		try {
			await import(`../lang/${lang}.json`);
			register(lang, async () => import(`../lang/${lang}.json`));
		} catch (importError) {
			console.error(
				`[i18n] Failed to load "${lang}" from both native and static import, falling back to English.`,
				importError,
			);
			lang = 'en';
		}
	}

	locale.set(lang);
	document.dir = lang === 'ar' ? 'rtl' : 'ltr';

	return lang;
}

export { format, _ };
